<canvas
    baseChart
    [data]="barChartData"
    [options]="barChartOptions"
    [type]="barChartType"
>
</canvas>